import { OCRDataReviewFormValues } from '@views/loans/components/OCRReviewForm';

import { apiUtils, getAccountBaseUrl } from '../../api-utils';
import { LoanDetail } from '../loan-api';


export async function getLoanDocuments(clientId: string, loanId: string, customerId?: string): Promise<LoanDocument[]> {
    return await apiUtils.get(`${getAccountBaseUrl(clientId, customerId)}/loan/${loanId}/document`);
}

export async function getOCRDataForDocument(
    clientId: string, loanId: string, documentId: string, customerId?: string
): Promise<Partial<LoanDetail>> {
    return await apiUtils.get(`${getAccountBaseUrl(clientId, customerId)}/loan/${loanId}/document/${documentId}/ocr-data`);
}

export async function getOCRSubmissionDataForDocument(
    clientId: string, loanId: string, documentId: string, customerId?: string
): Promise<OCRDataReviewFormValues | undefined> {
    return await apiUtils.get(`${getAccountBaseUrl(clientId, customerId)}/loan/${loanId}/document/${documentId}/ocr-submission`);
}

export async function updateOCRSubmissionDataForDocument(
    clientId: string, loanId: string, documentId: string, ocrData: OCRDataReviewFormValues, customerId?: string
): Promise<OCRDataReviewFormValues> {
    return await apiUtils.put(`${getAccountBaseUrl(clientId, customerId)}/loan/${loanId}/document/${documentId}/ocr-submission`, ocrData);
}

export async function getLoanDocumentUrl(
    clientId: string, loanId: string, documentId: string, customerId?: string
): Promise<PreSignedDocumentUrl> {
    return await apiUtils.get(`${getAccountBaseUrl(clientId, customerId)}/loan/${loanId}/document/${documentId}`);
}

// TODO replace uploadDocument with uploadDocuments
export function uploadLoanDocument(
    clientId: string, loanId: string, formData: FormData | File, customerId?: string
): Promise<void> {
    return apiUtils.post(`${getAccountBaseUrl(clientId, customerId)}/loan/${loanId}/document`, formData, {
        useAutoContentType: true,
        emptyResponse: true
    });
}

export interface PreSignedDocumentUrl {
    preSignedUrl: string;
    expiration: string; // ISO date
}

export interface LoanDocument {
    id: string;
    loanId: string;
    name: string;
    containerName: string;
    instanceCount: number;
    url: string;
    uploadedByUserId: string;
    uploadedAt?: string;
    isReviewed?: boolean;
}

export interface RequiredDoc {
    name: string;
    code: string;
    isUploaded: boolean;
    isReviewed: boolean;
    uploadedDoc?: LoanDocument;
}
